export const name = "ST_GEOGPOINTFROMGEOHASH";
export const summary = `Gets a point \`GEOGRAPHY\` value that's in the middle of a bounding box defined in a \`STRING\` GeoHash value.`;
export const reference = `
## ST_GEOGPOINTFROMGEOHASH

Gets a point \`GEOGRAPHY\` value that's in the middle of a bounding box defined in a \`STRING\` GeoHash value.

\`\`\`
ST_GEOGPOINTFROMGEOHASH(geohash)
\`\`\`

### Description

Returns a \`GEOGRAPHY\` value that corresponds to a point in the middle of a bounding box defined in the GeoHash.


### Return type

Point \`GEOGRAPHY\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
